import Model from 'src/models/model'
import { computed, ref } from 'vue'

/**
 * Returns the current Model.context object. This is useful for accessing
 * it while handling the possibility of it not having been loaded yet.
 */
export function useClientContext () {
  const isLoaded = ref(false)
  Model.ensureBooted().then(() => {
    isLoaded.value = true
  })
  const clientContext = computed(() => {
    return isLoaded.value ? Model.context : null
  })

  return {
    clientContext,
    isLoaded,
    ensureBooted: Model.ensureBooted
  }
}
